export default "__VITE_ASSET__CuYsVAF4__"